import React, { useCallback, useContext, useEffect } from "react";
import { Form, Divider, Button, Tooltip } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { Context } from "../EditorContext";
import { useThrottleFn } from "ahooks";

import FormCommonFieldConf from "../FormCommonField/FormCommonFieldConf";
import FormNumberConf from "../FormNumber/FormNumberConf";
import FormOptionConf from "../FormOption/FormOptionConf";
import FormDropdownConf from "../FormDropdown/FormDropdownConf";
import FormRadioGridConf from "../FormRadioGrid/FormRadioGridConf";
import FormRatingConf from "../FormRating/FormRatingConf";
import FormTermsConf from "../FormTerms/FormTermsConf";
import FormTextConf from "../FormText/FormTextConf";
import FormTextareaConf from "../FormTextarea/FormTextareaConf";
import FormSubmitButtonConf from "../FormSubmitButton/FormSubmitButtonConf";
import FormSignupSubmitButtonConf from "../FormSubmitButton/FormSignupSubmitButttonConf";
import TextConf from "../Text/TextConf";
import ImageConf from "../Image/ImageConf";
import DividerConf from "../Divider/DividerConf";
import CouponConf from "../Coupon/CouponConf";
import WechatFollowConf from "../WechatFollow/WechatFollowConf";
import WechatQRCodeConf from "../WechatQRCode/WechatQRCodeConf";
import WechatContentConf from "../WechatContent/WechatContentConf";
import WechatHeaderConf from "../WechatHeader/WechatHeaderConf";
import WechatContentImageConf from "../WechatTextImage/WechatContentImageConf";
import WechatSubscribeMessageConf from "../WechatSubscribeMessage/WechatSubscribeMessageConf";
import WechatTrackableQRCodeConf from "../WechatTrackableQRCode/WechatTrackableQRCodeConf";
import WechatLinkConf from "../WeChatLink/WechatLinkConf";
import HtmlBlockConfig from "../Html/HtmlBlockConfig";
import ButtonConf from "../Button/ButtonConf";
import MapConf from "../Map/MapConf";
import RowConf from "../Row/RowConf";
import HeadingConf from "../Heading/HeadingConf";
import CountdownConf from "../Countdown/CountdownConf";
import CloseIconConf from "../CloseButton/CloseButtonConf";
import TeaserConf from "../Teaser/TeaserConf";
import FormThankyouConf from "../FormThankyou/FormThankyouConf";
import FormPhoneConf from "../FormPhone/FormPhoneConf";


// content show in side bar config view
const CONF_MAPPING = {
  row: RowConf,
  heading: HeadingConf,
  text: TextConf,
  image: ImageConf,
  divider: DividerConf,
  coupon: CouponConf,
  button: ButtonConf,
  html: HtmlBlockConfig,
  countdown: CountdownConf,
  map: MapConf,
  "wechat-content": WechatContentConf,
  "wechat-follow": WechatFollowConf,
  "wechat-header": WechatHeaderConf,
  "wechat-link": WechatLinkConf,
  "wechat-qrcode": WechatQRCodeConf,
  "wechat-content-image": WechatContentImageConf,
  "wechat-subscribe-message": WechatSubscribeMessageConf,
  "wechat-trackable-qrcode": WechatTrackableQRCodeConf,
  "form-text": FormTextConf,
  "form-email": FormCommonFieldConf,
  "form-number": FormNumberConf,
  "form-date": FormCommonFieldConf,
  "form-phone": FormPhoneConf,
  "form-url": FormCommonFieldConf,
  "form-option": FormOptionConf,
  "form-multi-option": FormOptionConf,
  "form-radio-grid": FormRadioGridConf,
  "form-dropdown": FormDropdownConf,
  "form-textarea": FormTextareaConf,
  "form-rating": FormRatingConf,
  "form-terms": FormTermsConf,
  "form-submit-button": FormSubmitButtonConf,
  "form-signup-submit-button": FormSignupSubmitButtonConf,
  "form-thankyou": FormThankyouConf,
  "extra-close-button": CloseIconConf,
  "extra-teaser": TeaserConf,
};

export default ({ node }) => {
  const { shareRefs, notifySubscriber, sideContent } = useContext(Context);
  const [form] = Form.useForm();

  const { run: handlePropertyChange } = useThrottleFn(
    (_, data) => {
      setTimeout(() => {
        form.validateFields().then(() => {
          shareRefs.updateSelectContent(data);         
          notifySubscriber("DATA_CHANGE");
        }).catch(e => {
          console.log("Error in side config: ", e);
        });

      });
    },
    { wait: 200 }
  );

  const clearSelection = useCallback(() => {
    if (shareRefs.selectedNode) {
      shareRefs.selectedNode = null;
      shareRefs.updateSelectContent();
      shareRefs.updateSelectContent = null;
      notifySubscriber("NODE_SELECT");
    }
  }, [shareRefs, notifySubscriber]);

  useEffect(() => {
    shareRefs.contentConfigForm = form;
  }, [shareRefs, form]);

  const contentConf = sideContent.content[node.type] || {};

  return (
    <div
      className="config-form"
      style={{
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "white",
        padding: 12,
        zIndex: 2,
        overflowY: "auto",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <strong>Property</strong>
        <Tooltip overlay="Clear selection" placement="left">
          <Button onClick={clearSelection} shape="circle" size="small" icon={<CloseOutlined />} />
        </Tooltip>
      </div>
      <Divider style={{margin: "12px 0"}} />
      <Form
        form={form}
        layout="vertical"
        onValuesChange={handlePropertyChange}
        onFinish={(values) => handlePropertyChange(null, values)}
        initialValues={{...node.data, id: node.id}}
      >
        {React.createElement(CONF_MAPPING[contentConf.configComponent || node.type], { node })}
      </Form>
    </div>
  );
};
